import { useContext } from 'react'

import { Context, ThemeContext } from './theme-provider'

export const useTheme = (): Context => {
  const context = useContext(ThemeContext)
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider')
  }
  return context
}
